(($) => {
  function labelTrigger(fieldWrapper) {
    const label = fieldWrapper.querySelector('.nf-field-label');
    const field = fieldWrapper.querySelector('input, textarea, select');
    if (!field) return;
    let hasContent;

    const shiftLabelOut = () => {
      label.classList.add('--active');
    };

    const shiftLabelIn = () => {
      if (hasContent()) return;

      label.classList.remove('--active');
    };

    /* Set hasContent function to report whether there's something interesting in the field */
    switch (field.tagName) {
      case 'INPUT':
        hasContent = () => field.value.trim() !== '';
        break;
      case 'SELECT':
        hasContent = () => field.selectedIndex !== 0;
        break;
      case 'TEXTAREA':
        hasContent = () => field.value.trim() !== '';
        break;
      default:
    }

    field.addEventListener('focusin', shiftLabelOut);
    field.addEventListener('click', shiftLabelOut);
    field.addEventListener('focusout', shiftLabelIn);
  }

  function contactForm() {
    const contactFormContainer = document.querySelector('.contact__form');
    if (!contactFormContainer) return;

    $(document).on('nfFormReady', (e, form) => {
      const formEl = form.$el[0];

      // Not the one we're looking for
      if (!formEl.classList.contains('contact__form')) return;

      const fieldWrappers = formEl.querySelectorAll('.nf-field');
      fieldWrappers.forEach(labelTrigger);
    });
  }
  contactForm();

  function volunteerStudyForm() {
    const volunteerStudyFormContainer = document.querySelector('.volunteer-study-form');
    if (!volunteerStudyFormContainer) return;

    $(document).on('nfFormReady', (e, form) => {
      const formEl = form.$el[0];

      // Not the one we're looking for
      if (!formEl.classList.contains('volunteer-study-form')) return;

      const fieldWrappers = formEl.querySelectorAll('.nf-field');
      fieldWrappers.forEach(labelTrigger);
    });
  }
  volunteerStudyForm();

  function shareForm() {
    /* Share form, which is divided into 3 parts.
    The form areas are called states, but the indicator bubbles are called steps. */

    const shareFormContainer = document.querySelector('.share__form');
    if (!shareFormContainer) return;

    $(document).on('nfFormReady', (e, form) => {
      const formEl = form.$el[0];

      // Not the one we're looking for
      if (!formEl.classList.contains('share__form')) return;

      const numFormScreens = 3;
      const fieldsContainer = formEl.querySelector('nf-fields-wrap');
      const fieldWrappers = formEl.querySelectorAll('.nf-field');
      fieldWrappers.forEach(labelTrigger);

      const groupStatesIntoSections = () => {
        ['share__state1', 'share__state2', 'share__state3'].forEach((stateClass, idx) => {
          const stateNumber = idx + 1;
          const stateWrapper = document.createElement('div');
          stateWrapper.className = `share__state-wrapper share__state-wrapper-${stateNumber}`;
          stateWrapper.id = `share-state-${stateNumber}`;
          stateWrapper.tabIndex = -1;
          const fields = formEl.querySelectorAll(`.${stateClass}`);
          fields.forEach((field) => {
            const nfField = field.parentElement;
            const newChild = fieldsContainer.removeChild(nfField);
            stateWrapper.appendChild(newChild);
          });
          fieldsContainer.appendChild(stateWrapper);
        });
      };
      groupStatesIntoSections();

      const createControlSection = () => {
        const controlSection = document.createElement('div');
        controlSection.className = 'share__form-controls';

        // Previous button
        const previousButton = document.createElement('button');
        previousButton.className = 'share__form-button share__form-previous';
        previousButton.textContent = 'Previous';
        previousButton.type = 'button';
        previousButton.setAttribute('aria-label', 'Previous form field group');

        // Next button
        const nextButton = document.createElement('button');
        nextButton.className = 'share__form-button share__form-next';
        nextButton.textContent = 'Next';
        nextButton.type = 'button';
        nextButton.setAttribute('aria-label', 'Next form field group');

        // Submit button
        const submitButtonWrapper = fieldsContainer.querySelector('.submit-container').parentElement;
        fieldsContainer.removeChild(submitButtonWrapper);

        controlSection.appendChild(previousButton);
        controlSection.appendChild(nextButton);
        controlSection.appendChild(submitButtonWrapper);

        fieldsContainer.appendChild(controlSection);
      };
      createControlSection();

      const makeStateIndicator = () => {
        // Used as an anchor to insertBefore
        const formTitle = formEl.querySelector('.nf-form-title');
        if (!formTitle) return;

        const createStateBubble = (number) => {
          const stateBubble = document.createElement('div');
          stateBubble.className = `share__step share__step-${number}`;
          stateBubble.setAttribute('aria-hidden', true);
          stateBubble.id = `share-step-${number}`;
          stateBubble.textContent = number;
          return stateBubble;
        };

        const createStateLineConnector = () => {
          const lineConnector = document.createElement('div');
          lineConnector.className = 'share__step-connector';
          return lineConnector;
        };

        const stateSection = document.createElement('div');
        stateSection.className = 'share__step-indicator';
        stateSection.setAttribute('aria-label', 'Form progress');
        stateSection.setAttribute('role', 'progressbar');
        stateSection.setAttribute('aria-valuetext', 'Step 1');
        stateSection.setAttribute('aria-valuemin', '1');
        stateSection.setAttribute('aria-valuemax', numFormScreens);
        stateSection.setAttribute('aria-valuenow', '1');

        stateSection.appendChild(createStateBubble(1));

        for (let i = 2; i <= numFormScreens; i += 1) {
          stateSection.appendChild(createStateLineConnector());
          stateSection.appendChild(createStateBubble(i));
        }

        formEl.insertBefore(stateSection, formTitle);
      };
      makeStateIndicator();

      const states = formEl.querySelectorAll('.share__state-wrapper');
      const submitButtonWrapper = formEl.querySelector('.submit-container');

      const anyRadioButtonsChecked = (screenFields, name) => {
        const group = Array.from(screenFields)
          .filter((field) => (field.type === 'radio' && field.name === name));

        if (group === undefined) return false;

        return group.some((input) => input.checked);
      };

      const isNonNullField = (field, allFields) => {
        switch (field.tagName) {
          case 'SELECT':
            return field.selectedIndex !== 0;
          case 'INPUT':
            switch (field.type) {
              case 'text':
              case 'number':
                return field.value.trim() !== '';
              case 'email':
                return field.value.match(/.*?@.*?\..*/);
              case 'radio':
                return anyRadioButtonsChecked(allFields, field.name);
              default:
                return field.value !== '';
            }
          case 'TEXTAREA':
            return field.value !== '';
          default:
            return true;
        }
      };

      const allRequiredFieldsFilled = (screenFields) => {
        const requiredFields = Array.from(screenFields)
          .filter((field) => field.getAttribute('required') !== null);

        const fieldsFilled = requiredFields.every(
          (requiredField) => isNonNullField(requiredField, screenFields),
        );
        // This doesn't fully work because NF probably does validation asynchronously
        const fieldsGood = Array.from(screenFields)
          .every((screenField) => screenField.checkValidity());
        return fieldsFilled && fieldsGood;
      };

      const clearStepIndicator = () => {
        const stateIndicator = formEl.querySelector('.share__step-indicator');
        formEl.removeChild(stateIndicator);
      };

      const setCurrentState = (number) => {
        const indicatorProgress = formEl.querySelector('.share__step-indicator');
        const indicators = formEl.querySelectorAll('.share__step');
        const connectors = formEl.querySelectorAll('.share__step-connector');
        const previousButton = formEl.querySelector('.share__form-previous');
        const nextButton = formEl.querySelector('.share__form-next');
        const submitButton = submitButtonWrapper.querySelector('input');
        const currentScreen = formEl.querySelector(`.share__state-wrapper-${number}`);
        const currentScreenInputs = currentScreen.querySelectorAll('input, select, textarea');

        indicatorProgress.setAttribute('aria-valuenow', number);
        indicatorProgress.setAttribute('aria-valuetext', `Step ${number}`);

        const checkCanGoNext = () => {
          if (allRequiredFieldsFilled(currentScreenInputs)) {
            nextButton.removeAttribute('disabled');
          } else {
            nextButton.setAttribute('disabled', true);
          }
        };

        const checkCanSubmit = () => {
          const allInputs = formEl.querySelectorAll('input, select, textarea');
          if (allRequiredFieldsFilled(allInputs)) {
            submitButton.removeAttribute('disabled');
          } else {
            submitButton.setAttribute('disabled', true);
          }
        };

        indicators.forEach((indicator, idx) => {
          if (idx + 1 <= number) {
            indicator.classList.add('--active');
            return;
          }
          indicator.classList.remove('--active');
        });

        connectors.forEach((connector, idx) => {
          if (idx + 1 < number) {
            connector.classList.add('--active');
            return;
          }
          connector.classList.remove('--active');
        });

        states.forEach((state, idx) => {
          if (idx + 1 === number) {
            state.classList.remove('--hidden');
            return;
          }
          state.classList.add('--hidden');
        });

        if (number > 1) {
          previousButton.classList.remove('--hidden');
          previousButton.onclick = () => {
            const newScreenNumber = number - 1;
            setCurrentState(newScreenNumber);
            const previousScreen = formEl.querySelector(`.share__state-wrapper-${newScreenNumber}`);
            // Focus last item on previous page
            previousScreen.focus();
          };
        } else {
          previousButton.classList.add('--hidden');
        }

        if (number < numFormScreens) {
          nextButton.classList.remove('--hidden');
          checkCanGoNext();
          nextButton.onclick = () => {
            const newScreenNumber = number + 1;
            setCurrentState(newScreenNumber);
            const nextScreen = formEl.querySelector(`.share__state-wrapper-${newScreenNumber}`);
            // Focus next page
            nextScreen.focus();
          };
          // Bind form fields' change events to see if we can proceed
          currentScreenInputs.forEach((currentScreenInput) => {
            currentScreenInput.addEventListener('change', checkCanGoNext);
            currentScreenInput.addEventListener('keyup', checkCanGoNext);
          });
        } else {
          nextButton.classList.add('--hidden');
          nextButton.removeAttribute('disabled');
          // Unbind form fields' change events to see if we can proceed
          currentScreenInputs.forEach((currentScreenInput) => {
            currentScreenInput.removeEventListener('change', checkCanGoNext);
            currentScreenInput.removeEventListener('keyup', checkCanGoNext);
          });
        }

        if (number === numFormScreens) {
          submitButtonWrapper.classList.remove('--hidden');
          submitButton.addEventListener('click', clearStepIndicator);
          checkCanSubmit();

          // Bind form fields' change events to see if we can proceed
          currentScreenInputs.forEach((currentScreenInput) => {
            currentScreenInput.addEventListener('change', checkCanSubmit);
            currentScreenInput.addEventListener('keyup', checkCanSubmit);
          });
        } else {
          submitButtonWrapper.classList.add('--hidden');
          submitButton.removeEventListener('click', clearStepIndicator);
          submitButton.setAttribute('disabled', true);
          // Bind form fields' change events to see if we can proceed
          currentScreenInputs.forEach((currentScreenInput) => {
            currentScreenInput.removeEventListener('change', checkCanSubmit);
            currentScreenInput.removeEventListener('keyup', checkCanSubmit);
          });
        }
      };
      setCurrentState(1);
    });
  }
  shareForm();
})(jQuery);
